import { Box, useTheme, TextField, Button } from "@mui/material";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import PostAddIcon from "@mui/icons-material/PostAdd";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { tokens } from "../../theme";
import { useTranslation } from "react-i18next";

const FAQ = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t, i18n } = useTranslation();

  const [query, setQuery] = useState("");
  const [title, setTitle] = useState("");
  const [queries, setQueries] = useState([]);

  // Carga defaults traducidos cuando cambia el idioma
  useEffect(() => {
    setQueries([
      {
        title: t("faq.defaults.0.title"),
        query: t("faq.defaults.0.query"),
      },
    ]);
  }, [i18n.language, t]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const newQuery = { title, query };
    setQueries([...queries, newQuery]);
    setTitle("");
    setQuery("");
  };

  return (
    <Box m="20px">
      <Header title={t("faq.title")} subtitle={t("faq.subtitle")} />

      <form onSubmit={handleSubmit}>
        <TextField
          label={t("faq.form.titleLabel")}
          variant="filled"
          value={title}
          onChange={(event) => setTitle(event.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label={t("faq.form.queryLabel")}
          variant="filled"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          fullWidth
          margin="normal"
        />
        <Button
          type="submit"
          variant="contained"
          endIcon={<PostAddIcon />}
          color="success"
          size="large"
          sx={{ mt: 2, mb: 2 }}
        >
          {t("faq.form.submit")}
        </Button>
      </form>

      <br />

      <Box>
        {queries.map((q, i) => (
          <Accordion key={i}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography color={colors.greenAccent[500]} variant="h5">
                {q.title}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{q.query}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default FAQ;
